import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

const AgentFormModal = ({ isOpen, setModal, onSubmit, formData, setFormData, loading, clearData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Modal
        isOpen={isOpen}
        contentLabel="Agent Form"
        ariaHideApp={false}
        style={{
            content: {
                width: '600px',
                maxHeight: '85vh',
                margin: 'auto',
                overflow: 'auto',
                borderRadius: '16px',
                border: 'none',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
                padding: 0,
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 1000,
            }
        }}
    >
        <div className="bg-white">
            {/* Premium Header */}
            <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white px-8 py-5">
                <div className="flex items-start gap-3">
                    <div className="bg-white bg-opacity-20 p-3 rounded-lg">
                        <span className="text-3xl">👤</span>
                    </div>
                    <div>
                        <h2 className="text-2xl font-black mb-0.5">Add New Agent</h2>
                        <p className="text-blue-100 text-xs font-semibold">Complete the form to register a new agent</p>
                    </div>
                </div>
            </div>

            {/* Form Content */}
            <form onSubmit={onSubmit} className="p-6">
                {/* Personal Information Section */}
                <div className="mb-5">
                    <div className="flex items-center gap-3 mb-3.5">
                        <div className="w-1 h-7 bg-gradient-to-b from-blue-600 to-blue-400 rounded-full"></div>
                        <h3 className="text-base font-black text-gray-800">Personal Information</h3>
                    </div>
                    
                    <div className="space-y-3.5">
                        {/* Full Name */}
                        <div>
                            <label className="block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wider">
                                Full Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                className="w-full px-3.5 py-2.5 border-2 border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 text-sm text-gray-800 placeholder-gray-400 font-medium"
                                placeholder="Enter agent's full name"
                                required
                            />
                        </div>

                        {/* Gender and Nationality */}
                        <div className="grid grid-cols-2 gap-3.5">
                            <div>
                                <label className="block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wider">Gender</label>
                                <select
                                    name="gender"
                                    value={formData.gender}
                                    onChange={handleInputChange}
                                    className="w-full px-3.5 py-2.5 border-2 border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 text-sm text-gray-800 bg-white font-medium"
                                >
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wider">Nationality</label>
                                <input
                                    type="text"
                                    name="nationality"
                                    value={formData.nationality}
                                    onChange={handleInputChange}
                                    className="w-full px-3.5 py-2.5 border-2 border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 text-sm text-gray-800 placeholder-gray-400 font-medium"
                                    placeholder="e.g., Malaysian"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Information Section */}
                <div className="mb-5">
                    <div className="flex items-center gap-3 mb-3.5">
                        <div className="w-1 h-7 bg-gradient-to-b from-green-600 to-green-400 rounded-full"></div>
                        <h3 className="text-base font-black text-gray-800">Contact Information</h3>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-3.5">
                        <div>
                            <label className="block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wider">Mobile Number</label>
                            <input
                                type="text"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleInputChange}
                                className="w-full px-3.5 py-2.5 border-2 border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 text-sm text-gray-800 placeholder-gray-400 font-medium"
                                placeholder="+60123456789"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wider">Email Address</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                className="w-full px-3.5 py-2.5 border-2 border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 text-sm text-gray-800 placeholder-gray-400 font-medium"
                                placeholder="agent@example.com"
                            />
                        </div>
                    </div>
                </div>

                {/* Address Section */}
                <div className="mb-5">
                    <div className="flex items-center gap-3 mb-3.5">
                        <div className="w-1 h-7 bg-gradient-to-b from-purple-600 to-purple-400 rounded-full"></div>
                        <h3 className="text-base font-black text-gray-800">Address</h3>
                    </div>
                    
                    <label className="block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wider">Full Address</label>
                    <textarea
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-3.5 py-2.5 border-2 border-gray-300 rounded-md focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 text-sm text-gray-800 placeholder-gray-400 resize-none font-medium"
                        placeholder="Enter complete address including street, city, and postal code"
                    />
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-2.5 pt-4 border-t-2 border-gray-100">
                    <button
                        type="button"
                        onClick={() => clearData()}
                        className="px-5 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-sm rounded-lg transition-all duration-200"
                    >
                        🔄 Clear
                    </button>
                    <button
                        type="button"
                        onClick={() => setModal(false)}
                        className="px-5 py-2 bg-red-50 hover:bg-red-100 text-red-600 font-bold text-sm rounded-lg transition-all duration-200"
                    >
                        ✕ Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={loading}
                        className="px-7 py-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-blue-400 disabled:to-blue-400 text-white font-bold text-sm rounded-lg transition-all duration-200 disabled:cursor-not-allowed"
                    >
                        {loading ? "⏳ Processing..." : "✓ Add Agent"}
                    </button>
                </div>
            </form>
        </div>
    </Modal>
  );
};

export default AgentFormModal;
